// NAV: SUB HEADER MENUS - SEGMENTS

var fn_nav_subheadermenu = function () {


  // Removing scrolling from Body when Menu is opened
  $('.subheader__toggler-submenu').on('click', function () {

    var dataAriaValue = $(this).attr("aria-expanded");
    // console.log("The aria-expanded of Segments Toggler item is: " + dataAriaValue);

    if ( dataAriaValue === "false" ) {
      //$('body').css('overflow', 'hidden');
      $('body').addClass('overflow-hidden');
      // console.log('Segments opened');
    } else {
      //$('body').css('overflow', '');
      $('body').removeClass('overflow-hidden');
      // console.log('Segments closed');
    }

  });


  // > Closing all Panels on Resize and removing Class from Body
  var resizeTimer;
  $(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Run code here, resizing has "stopped"
      // console.log('window has been resized !');

      $('body').removeClass('overflow-hidden');
    }, 500);

  });




};
